import React, { cloneElement, Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Tabs, Tab, Paper } from 'material-ui';
import R from 'ramda';
import {
  getMetadata as getMetadataAction,
  getPosts as getPostsAction,
  getFollowers as getFollowersAction,
  getFollows as getFollowsAction,
} from '../../../stores/newsfeed/metaData/metaData-actions';
import {
  updateProps as updateNewsFeedPropsAction,
} from '../../../stores/newsfeed/actions';

const propTypes = {
  children: PropTypes.node,
  location: PropTypes.object,
  getPosts: PropTypes.func,
  getFollowers: PropTypes.func,
  getFollows: PropTypes.func,
  getMetadata: PropTypes.func,
  updateNewsFeedProps: PropTypes.func,
  gotMetaDataCount: PropTypes.bool,
  followersCount: PropTypes.number,
  followsCount: PropTypes.number,
  postsCount: PropTypes.number,
  followers: PropTypes.array,
  follows: PropTypes.array,
  posts: PropTypes.array,
  loading: PropTypes.bool,
};
class NewsfeedMetaDataContainer extends Component {
  componentWillMount() {
    const { gotMetaDataCount, getMetadata } = this.props;
    if (!gotMetaDataCount) getMetadata();
    const routeName = this.getRouteName(this.props);
    this.loadData(routeName);
  }

  componentWillReceiveProps(nextProps) {
    const previousRouteName = this.getRouteName(this.props);
    const newRouteName = this.getRouteName(nextProps);
    if (previousRouteName !== newRouteName) this.loadData(newRouteName);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }

  componentWillUnmount() {
    this.props.updateNewsFeedProps({ newsfeed: [] });
  }
  getRouteName = (props) => {
    const { location } = props;
    if (R.contains('posts', location.pathname)) return 'posts';
    if (R.contains('followers', location.pathname)) return 'followers';
    return 'follows';
  };

  loadData = (routeName) => {
    const { getPosts, getFollowers, getFollows, posts, follows, followers } = this.props;
    if (routeName === 'posts') {
      if (R.isEmpty(posts)) getPosts();
    }
    if (routeName === 'follows') {
      if (R.isEmpty(follows)) getFollows();
    }
    if (routeName === 'followers') {
      if (R.isEmpty(followers)) getFollowers();
    }
  };

  handleRouteChange = routeName => {
    this.context.router.push(`/newsfeed/meta/${routeName}`);
  };
  render() {
    const { children, ...extraProps } = this.props;
    const routeName = this.getRouteName(this.props);
    return (
      <Paper className="l-app-content">
        <Tabs
          value={routeName}
          onChange={this.handleRouteChange}
        >
          <Tab label={`Posts`} value="posts"/>
          <Tab label={`Follows`} value="follows"/>
          <Tab label={`Followers`} value="followers"/>
        </Tabs>
        {children ? cloneElement(children, extraProps) : undefined}
      </Paper>
    );
  }
}
NewsfeedMetaDataContainer.propTypes = propTypes;
NewsfeedMetaDataContainer.contextTypes = {
  router: PropTypes.object.isRequired,
};
const mapStateToProps = ({ newsfeedMetaData, newsfeed }) => ({
  ...newsfeedMetaData.toJS(),
  posts: newsfeed.get('newsfeed').toJS(),
});
const mapDispatchToProps = dispatch => ({
  getPosts: (...args) => dispatch(getPostsAction(...args)),
  getFollowers: (...args) => dispatch(getFollowersAction(...args)),
  getFollows: (...args) => dispatch(getFollowsAction(...args)),
  getMetadata: (...args) => dispatch(getMetadataAction(...args)),
  updateNewsFeedProps: (...args) => dispatch(updateNewsFeedPropsAction(...args)),
});
export default connect(mapStateToProps, mapDispatchToProps)(NewsfeedMetaDataContainer);



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/ownerMetaDataPages/main-router.jsx